

/* --- COMPANY DETAILS - FORM DATA START ---*/
export const employeeFormConfig = [
  {
    id: "basic",
    label: "Basic Info",
    fields: [
      {
        name: "photo",
        label: "Photo",
        type: "file",
        cols: 4,
      },
      {
        name: "name",
        label: "Full Name",
        type: "text",
        required: true,
        placeholder: "Enter full name",
        errorMessage: "Name is required",
        cols: 4,
      },
      {
        name: "dateOfBirth",
        label: "Date of Birth",
        type: "date",
        required: true,
        errorMessage: "Date of birth is required",
        cols: 4,
      },
      {
        name: "gender",
        label: "Gender",
        type: "select",
        required: true,
        errorMessage: "Gender is required",
        options: [
          { value: "Male", label: "Male" },
          { value: "Female", label: "Female" },
          { value: "Other", label: "Other" },
        ],
        cols: 4,
      },
      {
        name: "joiningDate",
        label: "Joining Date",
        type: "date",
        required: true,
        errorMessage: "Date of joining is required",
        cols: 4,
      },
      {
        name: "resignationDate",
        label: "Resignation Date",
        type: "date",
        cols: 4,
      },
      {
        name: "contractDate",
        label: "Contract Date",
        type: "date",
        cols: 4,
      },
      {
        name: "designation",
        label: "Designation",
        type: "select",
        source: "designations",
        cols: 4,
      },
      {
        name: "department",
        label: "Department",
        type: "select",
        source: "departments",
        cols: 4,
      },
      {
        name: "reportingManager",
        label: "Reporting Manager",
        type: "text",
        cols: 4,
      },{
        name: "bloodGroup",
        label: "Blood Group",
        type: "select",
        options: [
          { value: "A+", label: "A+" },
          { value: "A-", label: "A-" },
          { value: "B+", label: "B+" },
          { value: "B-", label: "B-" },
          { value: "O+", label: "O+" },
          { value: "O-", label: "O-" },
          { value: "AB+", label: "AB+" },
          { value: "AB-", label: "AB-" }
        ],
        cols: 4,
      }

      
    ],
  },
  {
    id: "contact",
    label: "Contact Info",
    fields: [
      {
        name: "personalMobileNo",
        label: "Personal Mobile No.",
        type: "text",
        required: true,
        pattern: "^[0-9]{10}$",
        errorMessage: "Invalid personal mobile number",
        cols: 4,
      },
      {
        name: "officeMobileNo",
        label: "Office Mobile No.",
        type: "text",
        required: true,
        pattern: "^[0-9]{10}$",
        errorMessage: "Invalid office mobile number",
        cols: 4,
      },
      {
        name: "personalEmail",
        label: "Personal Email",
        type: "email",
        cols: 4,
      },
      {
        name: "officeEmail",
        label: "Office Email",
        type: "email",
        required: true,
        errorMessage: "Office Email is required",
        cols: 6,
      },
      {
        name: "permanentAddress",
        label: "Permanent Address",
        type: "textarea",
        rows: 2,
        cols: 6,
      },
      {
        name: "permanentCity",
        label: "Permanent City",
        type: "text",
        cols: 3,
      },
      {
        name: "permanentState",
        label: "Permanent State",
        type: "text",
        source: "states",
        cols: 3,
      },
      {
        name: "permanentPinCode",
        label: "Permanent PIN Code",
        type: "text",
        cols: 3,
      },
      {
        name: "mailingAddress",
        label: "Mailing Address",
        type: "textarea",
        rows: 2,
        cols: 6,
      },
      {
        name: "mailingCity",
        label: "Mailing City",
        type: "text",
        cols: 3,
      },
      {
        name: "mailingState",
        label: "Mailing State",
        type: "select",
        source: "states",
        cols: 3,
      },
      {
        name: "mailingPinCode",
        label: "Mailing PIN Code",
        type: "text",
        cols: 3,
      },
    ],
  },
  {
    id: "identity",
    label: "Identity & Documents",
    fields: [
      {
        name: "panNumber",
        label: "PAN Number",
        type: "text",
        required: true,
        errorMessage: "PAN Number is required",
        cols: 4,
      },
      {
        name: "panCardDocument",
        label: "PAN Card",
        type: "file",
        cols: 4,
      },
      {
        name: "aadhaarNumber",
        label: "Aadhaar Number",
        type: "text",
        required: true,
        errorMessage: "Aadhaar Number is required",
        cols: 4,
      },
      {
        name: "aadhaarCardDocument",
        label: "Aadhaar Card",
        type: "file",
        cols: 4,
      },
      {
        name: "cvDocument",
        label: "CV / Resume",
        type: "file",
        cols: 4,
      },
      {
        name: "contractDocument",
        label: "Contract Document and NDA",
        type: "file",
        cols: 4,
      },
      {
        name: "lastQualification",
        label: "Last Qualification",
        type: "text",
        cols: 4,
      },
      {
        name: "lastQualificationCertificateDocument",
        label: "Qualification Certificate",
        type: "file",
        cols: 4,
      },
      {
        name: "passportDocument",
        label: "Passport",
        type: "file",
        cols: 4,
      },
      {
        name: "drivingLicenseDocument",
        label: "Driving License",
        type: "file",
        cols: 4,
      },
    ],
  },
  {
    id: "bank",
    label: "Bank Details",
    fields: [
      {
        name: "bankName",
        label: "Bank Name",
        type: "text",
        cols: 4,
      },
      {
        name: "accountNumber",
        label: "Account Number",
        type: "text",
        cols: 4,
      },
      {
        name: "ifscCode",
        label: "IFSC Code",
        type: "text",
        pattern: "^[A-Z]{4}0[A-Z0-9]{6}$",
        errorMessage: "Enter a valid IFSC code (e.g. SBIN0001234)",
        cols: 4,
      },
    ],
  },
  {
    id: "employment",
    label: "Employment & Security",
    fields: [
      // {
      //   name: "roles",
      //   label: "Role",
      //   type: "select",
      //   options: [
      //     { value: "admin", label: "Admin" },
      //     { value: "user", label: "User" }
      //   ],
      //   cols: 4,
      // },
      {
        name: "pfUan",
        label: "PF UAN",
        type: "text",
        cols: 4,
      },
      {
        name: "esiNumber",
        label: "ESI Number",
        type: "text",
        cols: 4,
      },
      // {
      //   name: "password",
      //   label: "Password",
      //   type: "text",
      //   cols: 4,
      // },
      {
        name: "branchName",
        label: "Office Location",
        type: "select",
        options: [
          { value: "kolkata", label: "Kolkata" },
          { value: "mumbai", label: "Mumbai" },
          { value: "hyderabad", label: "Hyderabad" },
          { value: "punjab", label: "Punjab" },
          { value: "lucknow", label: "Lucknow" },
          { value: "bhopal", label: "Bhopal" },
          { value: "delhi", label: "Delhi" },
          { value: "guwahati", label: "Guwahati" },
          { value: "bangalore", label: "Bangalore" },
          { value: "jaipur", label: "Jaipur" },
          { value: "visakhapatnam", label: "Visakhapatnam" },
          { value: "ahmedabad", label: "Ahmedabad" },
          { value: "kullu", label: "Kullu" },
        ],
        cols: 4,
      },
    ],
  },
  {
    id: "emergency",
    label: "Emergency Contact",
    fields: [
      {
        name: "emergencyContacts",
        label: "Emergency Contacts",
        type: "table",
        cols: 12,
        columns: [
          {
            name: "name",
            label: "Name",
            type: "text",
            required: false,
          },
          {
            name: "relationship",
            label: "Relationship",
            type: "select",
            required: false,
            options: [
              { value: "spouse", label: "Spouse" },
              { value: "father", label: "Father" },
              { value: "mother", label: "Mother" },
              { value: "son", label: "Son" },
              { value: "daughter", label: "Daughter" },
              { value: "brother", label: "Brother" },
              { value: "sister", label: "Sister" },
              { value: "other", label: "Other" },
            ],
            errorMessage: "Relationship is required",
          },
          {
            name: "mobileNumber",
            label: "Mobile Number",
            type: "text",
            required: false,
            pattern: "^[0-9]{10}$",
            errorMessage: "Enter a valid 10-digit mobile number",
          },
        ],
        addButtonText: "Add Contact",
        removeButtonText: "Delete Contact",
      },
    ],
  },
  {
    id: "salary",
    label: "Salary",
    fields: [
      {
        name: "salary",
        label: "Salary Components",
        type: "table",
        cols: 12,
        columns: [
          {
            name: "payRoleCompany",
            label: "Payroll Company",
            type: "select",
            cols: 12,
            required: true,
            options: [
              { value: "Apitco Ltd", label: "Apitco Ltd" },
              { value: "Foundation", label: "Foundation" },
            ],
            placeholder: "Select Payroll Company",
          },
          {
            name: "basicSalary",
            label: "Basic Salary",
            type: "number",
            required: true,
            min: 0,
          },
          {
            name: "hra",
            label: "HRA",
            type: "number",
            min: 0,
          },
          {
            name: "da",
            label: "DA",
            type: "number",
            min: 0,
          },
          {
            name: "tdsDeduction",
            label: "TDS Deduction %",
            type: "number",
            min: 0,
            max: 100,
          },
          {
            name: "professionalTax",
            label: "Professional Tax",
            type: "number",
            min: 0,
          },
          {
            name: "otherAllowance",
            label: "Other Allowance",
            type: "number",
            min: 0,
          },
          {
            name: "pfEmployeeContribution",
            label: "PF Employee %",
            type: "number",
            min: 0,
            max: 100,
          },
          {
            name: "pfEmployerContribution",
            label: "PF Employer %",
            type: "number",
            min: 0,
            max: 100,
          },
          {
            name: "esiContribution",
            label: "ESI %",
            type: "number",
            min: 0,
            max: 100,
          },
          {
            name: "effectiveDate",
            label: "Effective Date",
            type: "date",
            required: true,
          },
        ],
        addButtonText: "Add Salary Row",
        removeButtonText: "Delete Salary Row",
      },
    ],
  },
];

export const employeeFormTabs = employeeFormConfig.map((section) => ({
  id: section.id,
  label: section.label,
}));
